import React, { useState } from "react";
import { Building2, X } from "lucide-react";
import { Button, CircularProgress, Snackbar } from "@mui/material";
import ResetLinkSentModal from "./ResetLinkSentModal";
import axios from "axios";

const ProfileModal = ({
  setOpenProfileModal,
  openProfileModal,
}) => {
  const [activeTab, setActiveTab] = useState("profile");
  const [loader, setLoader] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const user_data = JSON.parse(localStorage.getItem("user"));

  const [snackMsg, setSnackMsg] = useState(null);
  const [openSnack, setOpenSnack] = useState(false);

  const [form, setForm] = useState({
    firstName: "John",
    lastName: "Doe",
    email: "john@example.com",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Example data (replace with real orgs if needed)
  const [organizations, setOrganizations] = useState(
    () => JSON.parse(localStorage.getItem("user"))?.relatedOrgs?.L || []
  );

  const [user, setUser] = useState(() => {
    const u = JSON.parse(localStorage.getItem("user"));
    if (!u) return null;
    return {
      user_id: u.userId?.S,
      email: u.email?.S ?? "",
      first_name: u.fName?.S ?? "",
      last_name: u.lName?.S ?? "",
      google: u?.registeredFromGoogle?.BOOL || false,
    };
  });

  // Current org from localStorage
  const orgData = JSON.parse(localStorage.getItem("organization"));
  const orgName = orgData?.organization_name?.S || "Select organization";
  const orgId = orgData?.orgId?.S;
  const displayName =
    orgName.length > 17 ? orgName.slice(0, 17) + "..." : orgName;

  async function sendResetLink() {
    setLoader(true);
    let check = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      {
        userId: JSON.parse(localStorage.getItem("user"))?.userId?.S,
      }
    );

    if (check.status === 200) {
      const user___ = check.data.user;

      if (
        user___.relatedOrgs.L?.find(
          (e) =>
            e?.M.org_id?.S ===
            JSON.parse(localStorage.getItem("organization")).orgId.S
        )
      ) {
        try {
          let response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "email/send-reset-link",
            {
              email: user.email,
              organization_id: JSON.parse(localStorage.getItem("organization"))
                .orgId.S,
              toName: user.first_name + " " + user.last_name,
              user_id: user.user_id,
            }
            );

          setOpenSuccessModal(true);

          setLoader(false);
        } catch (error) {
          // Log for production diagnostics when invite fails
          console.error("ProfileModal: invite failed", error.response?.data || error.message || error);
          if (error.response && error.response.data) {
            setSnackMsg(error.response.data.message);
            setOpenSnack(true);
          }
          setLoader(false);
        }
      } else {
        window.location.reload();
      }
    }
  }

  async function updateUser() {
    setLoader(true);
    let check = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      {
        userId: JSON.parse(localStorage.getItem("user"))?.userId?.S,
      }
    );

    if (check.status === 200) {
      const user___ = check.data.user;

      if (
        user___.relatedOrgs.L?.find(
          (e) =>
            e?.M.org_id?.S ===
            JSON.parse(localStorage.getItem("organization")).orgId.S
        )
      ) {
        try {
          const orgId = JSON.parse(localStorage.getItem("organization")).orgId.S;
          let user_data = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "user/update-user",
            { ...user, organization_id: orgId }
          );

          localStorage.setItem(
            "user",
            JSON.stringify(user_data.data.updatedUser)
          );

          setSnackMsg("User details successfully updated");
          setOpenSnack(true);

          setLoader(false);
        } catch (error) {
          // Log for production diagnostics when profile update fails
          console.error("ProfileModal: profile update failed", error.response?.data || error.message || error);
          if (error.response && error.response.data) {
            setSnackMsg(error.response.data.message);
            setOpenSnack(true);
          }
          setLoader(false);
        }
      } else {
        window.location.reload();
      }
    }
  }

  const deleteOrg = async (orgId) => {
    setLoader(true);
    let org = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "delete-organization",
      {
        userId: JSON.parse(localStorage.getItem("user"))?.userId?.S,
        orgId,
      }
    );

    localStorage.setItem("user", JSON.stringify(org.data.user));
    window.location.pathname = "/dashboard";
    setLoader(false);
  };


  const setMainOrg = async (orgId) => {
    setLoader(true);
    let org = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "user/set-main-org",
      {
        userId: JSON.parse(localStorage.getItem("user"))?.userId?.S,
        orgId,
      }
    );

    localStorage.setItem("user", JSON.stringify(org.data.user));
    setOrganizations(org.data?.user?.relatedOrgs?.L)
    setLoader(false);
  };


const changeOrganization = async (org_id) => {
    try {
      setLoader(true);
      const { fetchAndSetOrganization } = await import("../../utils/organizationService");
      await fetchAndSetOrganization(org_id);

      let user_data = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
        {
          userId: JSON.parse(localStorage.getItem("user"))?.userId?.S,
        }
      );
      localStorage.setItem("user", JSON.stringify(user_data.data.user));

      window.location.reload();
    } catch (error) {
      // Log for production diagnostics when switch organization fails
      console.error("ProfileModal: switch organization failed", error.response?.data || error.message || error);
      setLoader(false);
    }
  };

  if (!openProfileModal || !user_data || !user) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-[rgb(144,150,160,0.8)]">
      <ResetLinkSentModal
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        email={user.email}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openSnack}
        onClose={() => setOpenSnack(false)}
        message={snackMsg}
        key={snackMsg}
      />
      {/* Modal */}
      <div className="bg-white w-[400px] rounded-xl shadow-lg p-6 relative">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-800">My Profile</h2>
          <X
            className="w-5 h-5 text-gray-400 cursor-pointer hover:text-gray-600"
            onClick={() => setOpenProfileModal(false)}
          />
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-6  border-gray-200">
          {["profile", "organizations", "password"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`capitalize px-6 py-2 text-sm font-medium rounded-md ${
                activeTab === tab
                  ? "bg-indigo-50 text-indigo-600"
                  : "text-gray-600 hover:text-indigo-600"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Profile Form */}
        {activeTab === "profile" && (
          <form className="space-y-4">
            <div>
              <label className="block text-sm text-gray-600 mb-1">
                First Name
              </label>
              <input
                type="text"
                name="firstName"
                value={user.first_name}
                onChange={(e) => {
                  setUser({ ...user, first_name: e.target.value });
                }}
                className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">
                Last Name
              </label>
              <input
                type="text"
                name="lastName"
                value={user.last_name}
                onChange={(e) => {
                  setUser({ ...user, last_name: e.target.value });
                }}
                className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">
                Email Address
              </label>
              <input
                value={user.email}
                readOnly
                type="email"
                name="email"
                className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm bg-gray-50 text-gray-600 cursor-not-allowed focus:outline-none"
              />
              <p className="mt-1 text-xs text-gray-500">
                Email cannot be changed.
              </p>
            </div>

            <div className="flex justify-center gap-3 pt-4">
              <button
                type="button"
                onClick={updateUser}
                disabled={loader}
                className="px-4 py-2 bg-indigo-600 w-full text-white text-sm font-medium rounded-md hover:bg-indigo-700"
              >
                {loader ? (
                  <CircularProgress size={"1rem"} sx={{ color: "white" }} />
                ) : (
                  "   Save Changes"
                )}
              </button>
              <button
                type="button"
                onClick={() => {
                  setOpenProfileModal(false);
                }}
                className="px-4 py-2 bg-gray-100 w-full text-black text-sm font-medium rounded-md hover:bg-indigo-700"
              >
                Cancel
              </button>
            </div>
          </form>
        )}

        {/* Other Tabs */}
        {activeTab === "organizations" && (
          <div className="text-sm text-gray-600">
            <div className="text-[14px mb-4">
              {" "}
              Manage your organization memberships and set your main
              organization.{" "}
            </div>

            <div className="max-h-[280px] overflow-y-auto pr-1">
            {organizations.map((item, index) => (
              <div className=" border-[1px] border-gray-200 rounded-[6px] py-2 flex items-center justify-between px-3 mb-2">
                <div className="flex items-center space-x-2">
                  <Building2 className="w-4 h-4" />
                  <div className="font-semibold text-[14px]">
                    {item.M.org_name.S}
                  </div>
                </div>

                {orgId == item.M.org_id.S ? (
                  <div className="flex items-center space-x-2 ">
                    <div className="w-fit px-2 rounded-full bg-green-200 text-green-700 text-[13px] font-semibold">
                      Current
                    </div>
                    { item.M.main?.BOOL !== true ?(
                    <div className=" px-2  text-[13px] text-[#1E40AF] cursor-pointer " onClick={()=> setMainOrg(item.M.org_id.S)}>
                      Set as main
                    </div>) :
                  (
                    <div className="w-fit px-2 rounded-full bg-[#DBEAFE] text-[#1E40AF] text-[13px] font-semibold">
                      Main
                    </div>
                  )

                    }
                    
                  </div>
                ) : (
                  <div className="flex items-center  ">
                    {loader ? (
                      <CircularProgress size={"0.4rem"} sx={{ color: "gray" }} />
                    ): (
                      <>
                        <div
                      className=" px-2  text-[13px] text-[#1E40AF] cursor-pointer "
                      onClick={() => changeOrganization(item.M.org_id.S)}
                    >
                      Switch
                    </div>
                   { item.M.main?.BOOL !== true ?(
                    <div className=" px-2  text-[13px] text-[#1E40AF] cursor-pointer " onClick={()=> setMainOrg(item.M.org_id.S)}>
                      Set as main
                    </div>) :
                  (
                    <div className="w-fit px-2 rounded-full bg-[#DBEAFE] text-[#1E40AF] text-[13px] font-semibold">
                      Main
                    </div>
                  )

                    }
                    <div
                      className=" px-2  text-[13px] text-red-700 cursor-pointer "
                      onClick={() => deleteOrg(item.M.org_id.S)}
                    >
                      Remove
                    </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            ))}
            </div>
          </div>
        )}
        {activeTab === "password" && (
          <div className="text-sm text-gray-600 w-full">
            <div className="text-[14px mb-4">
              {" "}
              Manage your organization memberships and set your main
              organization.{" "}
            </div>
            <div className="w-[100%] flex items-center justify-center">
              <Button
                variant="contained"
                  color="primary"
                  sx={{
                  py: { lg: "8px", xs: "5px" },
                  px: "20px",
                  borderRadius: "12px",
                  fontSize: { lg: { lg: "14px", xs: "13px" }, xs: "12px" },
                  height: "fit",
                  width: "100%",
                }}
                onClick={sendResetLink}
                disabled={loader}
              >
                {loader ? (
                  <CircularProgress size={"1rem"} sx={{ color: "white" }} />
                ) : (
                  "  Reset Password"
                )}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileModal;
